import { OrderStatus } from "src/enums/order";

export const BATCH_UPLOAD_SIZE = 2;
export const SUCCESSFUL_STATUSES = [
  OrderStatus.SHIPPED,
  OrderStatus.DELIVERED,
  OrderStatus.PAYMENT_ON_DELIVERY,
  OrderStatus.PAID,
  OrderStatus.IN_PRODUCTION,
];

export const FAILED_BUT_OK_TO_RESUME_STATUSES = [
  OrderStatus.PENDING,
  OrderStatus.PROCESSING,
  OrderStatus.FAILED,
];

export const FAILED_STATUSES = [
  ...FAILED_BUT_OK_TO_RESUME_STATUSES,
  OrderStatus.CANCELED,
  OrderStatus.REFUNDED,
  OrderStatus.PROMOTIONAL,
];

// Statuses where the order is finished (from the user's perspective) and
// the session/cart should not be restored on return.
//
// This list is the client half of a contract with the backend's
// PAYABLE_STATUSES (photo-upload-backend/src/core/order/order.entity.ts): the
// backend takes an order to payment ONLY from PENDING, PROCESSING or FAILED, so
// every other status has to be terminal here. When the two disagreed, checkout
// offered a payment the backend then refused with a 400 the customer could not
// act on (FOTO-NEXTJS-14C).
//
// PROMOTIONAL is on this list for exactly that reason — a comped order is not
// payable. FAILED is deliberately NOT: it is a declined card, the customer must
// be able to try another one, and the backend accepts it.
export const TERMINAL_STATUSES = [
  ...SUCCESSFUL_STATUSES,
  OrderStatus.CANCELED,
  OrderStatus.REFUNDED,
  OrderStatus.PARTIALLY_REFUNDED,
  OrderStatus.PROMOTIONAL,
];
